import { useState } from 'react';
import { useTranslation } from '@klv/hooks/useTranslation';
import { generateClassName } from '@klv/shared/utils/functions';
import Button from '@klv/atoms/button';
import Icon from '@klv/atoms/icon';
import RequestForm from './components/AccountAccessForm';

import * as s from './styles/accountAccessForm.module.css';

import type { ISupportFormIndex } from './types';

const AccountAccessForm = ({
  backgroundColor = 'light',
}: ISupportFormIndex) => {
  const [success, setSuccess] = useState(false);
  const { t } = useTranslation();

  if (success) {
    return (
      <div className={s.successContainer}>
        <Icon className={s.icon} iconName='BugMarkFilled' color='currentColor' />
        <h3 className={generateClassName([s.successHeadline, 'h3', 'medium'])}>
          {t('organisms_forms_accountAccessForm_success_headline')}
        </h3>
        <p className={generateClassName([s.successSubhead, 'p2'])}>
          {t('organisms_forms_accountAccessForm_success_subhead')}
        </p>
        <Button
          text={t('organisms_forms_accountAccessForm_success_button_label')}
          buttonColor='dark'
          variant='primary'
          url={t('organisms_forms_accountAccessForm_success_button_href')}
        />
      </div>
    );
  }
  return (
    <RequestForm backgroundColor={backgroundColor} setSuccess={setSuccess} />
  );
};

export default AccountAccessForm;
